import { Grid, Typography } from '@mui/material';
import { FileUploadSolid } from '@assets/svgs';

export const Dropzone = ({
  sxProps,
}: {
  sxProps?: {
    dropzoneContainerSx?: object;
  };
}) => (
  <Grid
    container
    direction='column'
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',

      // TODO clean up hex codes
      backgroundColor: '#F4F4F1E6',

      width: '100%',
      height: '100%',
      zIndex: '2',
      marginTop: '45px',
      padding: '0 41px',
      textAlign: 'center',
      pointerEvents: 'none',
      ...sxProps?.dropzoneContainerSx,
    }}
  >
    <FileUploadSolid width='30px' height='40px' color='secondary.main' />
    <Typography
      variant='subtitle'
      sx={{
        fontWeight: '700',
        color: 'secondary.main',
        margin: '12px 0 8px 0',
      }}
    >
      Attach files
    </Typography>
    <Typography variant='bodySmall'>
      Drag and drop .mp4, .png, .jpg, .gif, .docx, .xls, .pptx, .pdf, .msg, .csv or .txt files. Maximum file size is 10
      MB
    </Typography>
  </Grid>
);
